import React, { useState, useEffect } from 'react';

import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from '../componentes/Menu';
import dataSuper from "../hooks/Conf";
import dataDireccionEstudiantil from '../hooks/useDireccionEstudiantil';
import dataFinanzas from '../hooks/useFinzas';
import CarAlumnoDatos from '../element/CarAlumnoDatos';
import CarSolvencia from "../element/CarSolvencia";
import SkeletonCard from "../element/Skeleton";
import EmptyState from "../element/EmptyState";
// Contexto
// import dataContext from "../context/User";

// Helper 
import GetFetch from "../helper/GetFetch";
import loadMenu from '../js/main';
import Footer from '../componentes/Footer';

import '../css/styleAdmin.css';
// import { data } from 'jquery';

const AlumnosSolvencias = () => {

    const history = useHistory();

    // const dataUser = useContext(dataContext);
    let datos = localStorage.getItem('dataUser');

    if (!datos) {
        history.push("/");
    }

    datos = JSON.parse(datos);

    if (dataSuper.indexOf(datos.carnet.trim()) === -1) {
        if (dataDireccionEstudiantil.indexOf(datos.carnet.trim()) === -1 && dataFinanzas.indexOf(datos.carnet.trim()) === -1 ) {
          history.push("/");
        }
      }  

    const [carnet, setCarnet] = useState({});
    const [solvencia, setSolvencia] = useState({});
    const [alumno, setAlumno] = useState({});
    const [cargando, setCargando] = useState(false);

    let carnetSet = (e) => {
        setCarnet(e.target.value)
    }


    let onSutmit = (e) => {
        e.preventDefault();
        localStorage.setItem('currentCarnet', carnet);
        setCargando(true);
        let solvencia = GetFetch.solvencia(carnet, datos.token);
        solvencia.then((dataSolvencia) => {
            document.getElementById('dataContenedorAlumno').style.display = 'block';
            document.getElementById('tableSolvencia').style.display = 'block';
            setSolvencia(dataSolvencia);
            AlumnoDatos();
            setCargando(false);
        }).catch(() => setCargando(false));
    }

    let AlumnoDatos = () => {
       
            let datosAlum = GetFetch.datosAlumno(carnet, datos.token);
            datosAlum.then((data) => {
            if (data[0]) {
                setAlumno(data[0]);
            }
        });
        
        
    }

    useEffect(() => {
        let currentCarnet = localStorage.getItem('currentCarnet');
        if (currentCarnet) {
            setCarnet(currentCarnet);
        }else{
            setCarnet('');
        }
        loadMenu();
        document.getElementById('textCarnet').focus();
    }, []);

    return (
        <div className="wrapper d-flex align-items-stretch">
            <nav id="sidebar">
                <div className="custom-menu">
                    <button
                        type="button"
                        id="sidebarCollapse"
                        className="btn btn-primary"
                    >
                        <i className="fa fa-bars"></i>
                        <span className="sr-only">Toggle Menu</span>
                    </button>
                </div>
                <div className="p-4">
                    <Foto
                        foto={datos.carnet}
                        alt="Foto alumno"
                        tamanio="rounded" />

                    <HeaderMenu
                        carnet={datos.carnet}
                        nombre={datos.nombre}
                        perfil={datos.perfil}
                        carrera={datos.carrera}
                        posicion="text-center"
                    />

                    <Menu />

                    <Footer />
                </div>
            </nav>

            <div id="content" className="p-4 p-md-5 pt-5">
                <h2 className="mb-4">Solvencia por alumno</h2>

                <div className="card mb-4">
                    <div className="card-body">
                        <form id='formUP' onSubmit={onSutmit}>
                            <div className="form-group">
                                <label htmlFor="textCarnet">Carnet del alumno</label>
                                <input id="textCarnet" type="text" placeholder="Carnet" className="form-control" onChange={carnetSet} value={carnet} />
                            </div>
                            <button type="submit" className="btn btn-primary">
                                <i className="fa fa-search mr-2" aria-hidden="true"></i>
                                Buscar
                            </button>
                        </form>
                    </div>
                </div>

                <CarAlumnoDatos
                    alumno={alumno}
                />

                {cargando ? <SkeletonCard rows={4} /> : null}

                {!cargando && solvencia.length === undefined ? (
                    <EmptyState icon="fa-search" title="Busca un alumno por carnet">
                        Ingresa el carnet del alumno y presiona Buscar para consultar su solvencia financiera.
                    </EmptyState>
                ) : null}

                <div id="tableSolvencia" style={{ display: 'none' }}>
                    <div className="card">
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th scope="col">Componente administrativo</th>
                                            <th scope="col">Estado</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {solvencia.length > 0 ? (
                                            solvencia.map((element, i) => (
                                                <CarSolvencia
                                                    key={i}
                                                    componente={element.componente}
                                                    solvencia={element.solvencia}
                                                />
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="2" className="text-muted">
                                                    Aún no hay componentes administrativos para mostrar.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default AlumnosSolvencias;